"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IngestAssetRequestToJSON = exports.IngestAssetRequestFromJSONTyped = exports.IngestAssetRequestFromJSON = exports.instanceOfIngestAssetRequest = void 0;
var runtime_1 = require("../runtime");
var MediaFileType_1 = require("./MediaFileType");
/**
 * Check if a given object implements the IngestAssetRequest interface.
 */
function instanceOfIngestAssetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "mediaFileType" in value;
    isInstance = isInstance && "pretranscodeStoragePath" in value;
    isInstance = isInstance && "transcodeSourceId" in value;
    return isInstance;
}
exports.instanceOfIngestAssetRequest = instanceOfIngestAssetRequest;
function IngestAssetRequestFromJSON(json) {
    return IngestAssetRequestFromJSONTyped(json, false);
}
exports.IngestAssetRequestFromJSON = IngestAssetRequestFromJSON;
function IngestAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mediaFileType': (0, MediaFileType_1.MediaFileTypeFromJSON)(json['media_file_type']),
        'pretranscodeStoragePath': json['pretranscode_storage_path'],
        'imageUrl': !(0, runtime_1.exists)(json, 'image_url') ? undefined : json['image_url'],
        'transcodeSourceId': json['transcode_source_id'],
        'width': !(0, runtime_1.exists)(json, 'width') ? undefined : json['width'],
        'height': !(0, runtime_1.exists)(json, 'height') ? undefined : json['height'],
    };
}
exports.IngestAssetRequestFromJSONTyped = IngestAssetRequestFromJSONTyped;
function IngestAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'media_file_type': (0, MediaFileType_1.MediaFileTypeToJSON)(value.mediaFileType),
        'pretranscode_storage_path': value.pretranscodeStoragePath,
        'image_url': value.imageUrl,
        'transcode_source_id': value.transcodeSourceId,
        'width': value.width,
        'height': value.height,
    };
}
exports.IngestAssetRequestToJSON = IngestAssetRequestToJSON;
